export { NotFoundPage as default } from './utilcomponents';
